import { render, staticRenderFns } from "./CourseRequired.vue?vue&type=template&id=0e4780fe&scoped=true"
import script from "./CourseRequired.vue?vue&type=script&lang=js"
export * from "./CourseRequired.vue?vue&type=script&lang=js"
import style0 from "./CourseRequired.vue?vue&type=style&index=0&id=0e4780fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4780fe",
  null
  
)

export default component.exports